<form [formGroup]="formularioAdicionar" autocomplete="off">
    <app-loading *ngIf="loading"></app-loading>

    <div class="container-preview">
        <span class="block-hero_line"></span>
        <div class="continer-top-preview">
            <div class="container-logo-preview">
                <img src="assets/img/logo.svg" alt="logo">
            </div>
            <div class="container-titulo-preview">
                <h1>{{campaign != null ? campaign.name : ''}}</h1>
            </div>
        </div>
        <div class="container-content-preview">
            <div class="container-diagonales">
                <span class="diagonal"></span>
                <span class="diagonal"></span>
                <span class="diagonal"></span>
                <span class="diagonal"></span>
                <span class="text-diagonales">Filtros</span>
            </div>
            <div class="container-filtros" *ngIf="showCampaign">
                <!--<h2>Filtros:</h2>-->
                <br>
                <p>Seleccione al menos un filtro para continuar</p>
                <div *ngFor="let filter of filters">
                    <div *ngIf="filter.filter.filter_size === 0">
                    <mat-form-field appearance="fill" class="custom-select">
                      <mat-label>{{filter.filter.name}}</mat-label>
                      <mat-select [formControlName]="filter.filter.name" disableOptionCentering>
                        <mat-option [value]="''">Todos</mat-option>
                        <mat-option *ngFor="let data of filter.data" [value]="data.data">
                          <span [innerHTML]="sanitizeHtml(data.data)"></span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    </div>
                </div>
                <button class="btn red mb-2"
                    (click)="getData()">
                    <span>Crear</span><span class="btn-arrow"></span>
                </button>
            </div>
            <div class="content-preview">
                <div style="display: flex; flex-wrap: wrap; align-items: flex-start;margin-bottom: 40px;" *ngIf="filteredFormats().length > 0">
                    <div class="card-iframe" *ngFor="let format of filteredFormats(); let i = index">

                        <iframe [src]="format.safeHtml"
                            [width]="format.width"
                            [height]="format.height"
                            [attr.id]="'iframe-' + i + '-' + (format.data?.['field_1']?.toString() || '')">
                            <p>Your browser does not support iframes.</p>
                        </iframe>
                        <span class="title-creative" [innerHTML]="format.data?.['field_2']?.toString() || ''"></span>
                        <span class="title-creative">{{format.name}}</span>
                        <button class="btn red btn-recargar"
                            (click)="refreshIframe(i + '-' + (format.data?.['field_1']?.toString() || ''))">
                            Recargar creativo
                        </button>
                    </div>
                </div>

                <div class="row" style="width: 100%;position: absolute;bottom: 0;right: 0;">
                    <div class="col-md-12">
                        <div fxLayout="row" class="text-center {{ loading === true ? 'd-none' : '' }}">
                            <mat-paginator #paginator
                                [length]="total"
                                pageSize="30"
                                (page)="obtenerDataPagina($event)"
                                [pageSizeOptions]="[30]"
                                showFirstLastButtons="true"
                                aria-label="Seleccione página">
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="container-footer-preview">
            Ads-Previews.com
        </div>

    </div>
</form>



